import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { HEADER_STATES } from 'src/app/shared/header/header.helper';
import { APP_COLORS } from 'src/global-styles';
import { SneWrittenCommunicationBase } from '../sne-written-communication.base';

@Component({
  selector: 'ets-wc-sne-intro',
  templateUrl: './wc-sne-intro.component.html',
  styleUrls: ['./wc-sne-intro.component.scss']
})
export class WcSneIntroComponent extends SneWrittenCommunicationBase implements OnInit {

  headerState: HEADER_STATES = HEADER_STATES.BACK;

  APP_COLORS = APP_COLORS;
  numberText = '05.';

  constructor(route: ActivatedRoute, router: Router, sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }

  onClick(){
    this.getNextQuestion();
  }

  ngOnInit(): void {
    this.processParams();
  }

}
